import { ITheme } from '../interfaces/themeInterface/index';

export type TSelect = 'popularity' | 'latest' | 'name';
export const popularityOrder = [
    'Spotlight',
    'Newsroom',
    'Pitch',
    'Principle',
    'The Reporter',
    'Digital Nomad',
    'Paragraph',
    'Reflect',
    "Paradigm",
    'Digital',
    'Persona',
    "Hype"
];

const getFilteredData = (data: Partial<ITheme>[], activeOption: TSelect) => {
    switch (activeOption) {
        case 'popularity':
            return data.slice().sort((a: Partial<ITheme>, b: Partial<ITheme>) => {
                return popularityOrder.indexOf(a.title!) - popularityOrder.indexOf(b.title!);
            });
        case 'latest':
            return data.slice().sort((a: Partial<ITheme>, b: Partial<ITheme>): number => {
                const dateA = new Date(a._createdAt!);
                const dateB = new Date(b._createdAt!);
                return dateB.getTime() - dateA.getTime();
            });
        case 'name':
            return data.slice().sort((a: Partial<ITheme>, b: Partial<ITheme>) => {
                return a.title!.localeCompare(b.title!);
            });
        default:
            return data;
    }
};

export { getFilteredData };
